module.exports = "<router-outlet></router-outlet>\n<ngx-ui-loader></ngx-ui-loader>"